<template>
<div v-if="botCount > 0 || trackCount > 0" class="alert alert-danger pw-banner" role="status">
<div v-if="botCount > 0" class="pw-row">
<div class="pw-icon"><i class="fas fa-exclamation-triangle" aria-hidden="true"></i></div>
<div class="pw-text">
<div class="pw-title">บอทไม่ตอบแชทในเพจ Facebook {{ botCount }}&nbsp;เพจ: <b>{{ botNames }}</b></div>
<div class="pw-line">เชื่อมใหม่ที่ bot.proship: เพจที่จะใช้งาน → เชื่อมเพจ Facebook แล้วติ๊กทุกเพจที่ยังใช้อยู่</div>
</div>
<a class="btn pw-btn" :href="webUrl" @click="openLink" target="_blank" rel="noopener">เชื่อมเพจใหม่ <i class="fal fa-external-link" aria-hidden="true"></i></a>
</div>
<div v-if="botCount > 0 && trackCount > 0" class="pw-divider" role="presentation"></div>
<div v-if="trackCount > 0" class="pw-row">
<div class="pw-icon"><i class="fas fa-exclamation-triangle" aria-hidden="true"></i></div>
<div class="pw-text">
<div class="pw-title">ลูกค้าไม่ได้รับเลขแทร็คจากเพจ Facebook {{ trackCount }}&nbsp;เพจ: <b>{{ trackNames }}</b></div>
</div>
<button type="button" class="btn pw-btn" :disabled="connecting" @click="connect">เชื่อมเพจ</button>
</div>
</div>
</template>
<script>
import { mapGetters } from "vuex";
import { BOT_WEB_URL, openBotLink } from "@/helpers/botLink";
import { connectMessengerPage } from "@/helpers/connectMessengerPage";
export default {
name: "PageWarningsBanner",
data() {
return { webUrl: BOT_WEB_URL, connecting: false };
},
methods: {
openLink(e) {
openBotLink(e, this.$store);
},
connect() {
connectMessengerPage(this);
}
},
computed: {
...mapGetters("botPages", { botCount: "count", botNames: "names" }),
...mapGetters("trackingPages", { trackCount: "count", trackNames: "names" })
}
};
</script>
<style scoped>
.alert.pw-banner {
margin: 0; border: 0; border-radius: 0; width: 100%;
background-color: #c62828; color: #fff; padding: 14px 20px;
}
.pw-row { display: flex; flex-wrap: wrap; align-items: center; gap: .75rem 1rem; }
.pw-divider { height: 1px; background: rgba(255, 255, 255, .45); margin: 12px 0; }
.pw-icon { font-size: 30px; line-height: 1; flex: 0 0 auto; }
.pw-text { flex: 1 1 18rem; min-width: 0; overflow-wrap: anywhere; }
.pw-title { font-weight: 700; font-size: 18px; line-height: 1.35; }
.pw-line { font-size: 14px; margin-top: .15rem; opacity: .95; }
.alert.pw-banner .btn.pw-btn {
flex: 0 0 auto; background: #fff; color: #c62828; font-weight: 700; border: 1px solid #fff;
white-space: nowrap; text-decoration: none; font-size: 15px; padding: 8px 18px; min-height: 44px;
}
.alert.pw-banner .btn.pw-btn:hover { background: #ffecec; color: #a31515; }
.alert.pw-banner .btn.pw-btn:focus-visible { outline: 3px solid #fff; outline-offset: 2px; }
.pw-btn .fa-external-link { font-size: 12px; margin-left: .25rem; }
@media (max-width: 575.98px) {
.alert.pw-banner { padding: 12px 16px; }
.pw-title { font-size: 16px; }
.alert.pw-banner .btn.pw-btn { margin-left: calc(30px + 1rem); }
}
</style>

